import { useEffect, useState } from "react";
import client from "../api/client";

const styles = {
  page: { fontSize: 11, minHeight: "100%", overflow: "visible", padding: 0 },
  card: {
    border: 0,
    borderRadius: 14,
    overflow: "hidden",
    boxShadow: "0 2px 10px rgba(0,0,0,.08)",
    background: "#fff",
  },
  header: {
    background: "linear-gradient(90deg, #22052D, #CCB3D1)",
    color: "#fff",
    padding: "8px 12px",
  },
  title: { fontSize: 13, fontWeight: 700, margin: 0 },
  sub: { fontSize: 10, opacity: 0.85 },
  body: { padding: 10 },
  input: { height: 30, fontSize: 11, borderRadius: 7 },
  btn: { height: 30, fontSize: 11, borderRadius: 7, fontWeight: 600 },
  tableWrap: {
    maxHeight: 420,
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #e9ecef",
    borderRadius: 10,
  },
  table: { fontSize: 11, minWidth: 700, marginBottom: 0 },
  th: {
    fontSize: 10,
    padding: "7px 8px",
    whiteSpace: "nowrap",
    color: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 1,
  },
  td: {
    fontSize: 11,
    padding: "6px 8px",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  badge: {
    fontSize: 10,
    padding: "4px 7px",
    borderRadius: 20,
    fontWeight: 600,
  },
};

export default function AccountsPage() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({
    accountCode: "",
    accountName: "",
    accountType: "Asset",
  });

  const load = async () => {
    const res = await client.get("/accounts");
    setRows(Array.isArray(res.data) ? res.data : []);
  };

  useEffect(() => {
    load();
  }, []);

  const save = async () => {
    if (!form.accountCode || !form.accountName) {
      alert("Please fill all fields");
      return;
    }

    await client.post("/accounts", form);
    setForm({ accountCode: "", accountName: "", accountType: "Asset" });
    load();
  };

  const badgeClass = (type) => {
    if (type === "Asset") return "text-bg-success";
    if (type === "Liability") return "text-bg-danger";
    if (type === "Income") return "text-bg-primary";
    if (type === "Expense") return "text-bg-warning";
    return "text-bg-secondary";
  };

  return (
    <div className="container-fluid py-2" style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>
          <h6 style={styles.title}>
            <i className="bi bi-wallet2 me-2"></i>
            Accounts
          </h6>
          <div style={styles.sub}>
            Chart of accounts for finance and reports
          </div>
        </div>

        <div style={styles.body}>
          <div className="row g-2 mb-2">
            <div className="col-md-3">
              <input
                className="form-control form-control-sm"
                style={styles.input}
                placeholder="Account Code"
                value={form.accountCode}
                onChange={(e) =>
                  setForm({ ...form, accountCode: e.target.value })
                }
              />
            </div>

            <div className="col-md-4">
              <input
                className="form-control form-control-sm"
                style={styles.input}
                placeholder="Account Name"
                value={form.accountName}
                onChange={(e) =>
                  setForm({ ...form, accountName: e.target.value })
                }
              />
            </div>

            <div className="col-md-3">
              <select
                className="form-select form-select-sm"
                style={styles.input}
                value={form.accountType}
                onChange={(e) =>
                  setForm({ ...form, accountType: e.target.value })
                }
              >
                <option>Asset</option>
                <option>Liability</option>
                <option>Equity</option>
                <option>Income</option>
                <option>Expense</option>
              </select>
            </div>

            <div className="col-md-2 d-grid">
              <button
                className="btn btn-success btn-sm"
                style={styles.btn}
                onClick={save}
              >
                <i className="bi bi-check2-circle me-1"></i>
                Save
              </button>
            </div>
          </div>

          <div
            style={{
              fontSize: 10,
              color: "#6c757d",
              marginBottom: 6,
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span>
              Total Accounts: <strong>{rows.length}</strong>
            </span>
            <span>Account master</span>
          </div>

          <div style={styles.tableWrap}>
            <table
              className="table table-bordered table-hover align-middle"
              style={styles.table}
            >
              <thead>
                <tr>
                  <th style={{ ...styles.th, minWidth: 140 }}>Code</th>
                  <th style={{ ...styles.th, minWidth: 320 }}>Account Name</th>
                  <th style={{ ...styles.th, minWidth: 140 }}>Type</th>
                </tr>
              </thead>

              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td
                      colSpan="3"
                      className="text-center text-muted"
                      style={{ ...styles.td, padding: 18 }}
                    >
                      No accounts found
                    </td>
                  </tr>
                ) : (
                  rows.map((r, i) => {
                    const type = r.AccountType ?? r.accountType;

                    return (
                      <tr key={i}>
                        <td style={{ ...styles.td, fontWeight: 700 }}>
                          {r.AccountCode ?? r.accountCode}
                        </td>
                        <td style={styles.td}>
                          {r.AccountName ?? r.accountName}
                        </td>
                        <td style={styles.td}>
                          <span
                            className={`badge ${badgeClass(type)}`}
                            style={styles.badge}
                          >
                            {type}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
